/*!
  Dynamic prices for pages and blog posts — Sunhats
  Usage in page/blog HTML:
    <p class="blog-product-price" data-price-handle="gilly">From R699</p>
  The text inside is the fallback; on page load it is replaced with the live
  price from /products/<handle>.js. Shows "From" only when variants differ in
  price, and a struck-through old price when the product is on sale.
  Optional: data-from-label="Vanaf" to translate "From".
*/
(function () {
  var els = document.querySelectorAll('[data-price-handle]');
  if (!els.length) return;

  var moneyFormat = (window.theme && theme.settings && theme.settings.moneyFormat) || 'R{{amount_no_decimals}}';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function formatMoney(cents) {
    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var comma = placeholder.indexOf('comma') !== -1;   // e.g. 1.099,50
    var value = cents / 100;
    var decimals = (cents % 100 === 0) ? 0 : 2;        // R699 instead of R699.00
    var parts = value.toFixed(decimals).split('.');
    var thousands = comma ? '.' : ',';
    var decimal = comma ? ',' : '.';
    var number = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
    return match ? moneyFormat.replace(match[0], number) : number;
  }

  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    return cache[handle];
  }

  els.forEach(function (el) {
    getProduct(el.getAttribute('data-price-handle'))
      .then(function (p) {
        var from = p.price_varies ? (el.getAttribute('data-from-label') || 'From') + ' ' : '';
        var html = from + formatMoney(p.price_min);
        if (p.compare_at_price_min && p.compare_at_price_min > p.price_min) {
          html += ' <s style="opacity:.55;font-weight:400;margin-left:.35rem;">' + formatMoney(p.compare_at_price_min) + '</s>';
        }
        el.innerHTML = html;
      })
      .catch(function () { /* keep the fallback text */ });
  });
})();